import React from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import DeleteIcon from '@material-ui/icons/Delete';
import ErrorIcon from '@material-ui/icons/Error';

import './ErrorBoundary.scss';

const ErrorItem = (props) => {
  const { error } = props;
  const makeLineKey = (iLine) => {
    return `${error.time}-${iLine}`;
  };
  return (
    <ListItem className="tuc-error-item">
      <ListItemAvatar>
        <Avatar>
          <ErrorIcon />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={error.message}
        secondary={error.description && (
          <React.Fragment>
            {error.description.split('\n').map((line, iLine) => (
              <Typography key={makeLineKey(iLine)} variant="caption">{line}</Typography>
            ))}
          </React.Fragment>
        )}
      />
      <ListItemSecondaryAction>
        {error.deletable && (
          <IconButton aria-label="Delete" onClick={props.onDeleteError(error)}>
            <DeleteIcon />
          </IconButton>
        )}
      </ListItemSecondaryAction>
    </ListItem>
  );
};

ErrorItem.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string,
    description: PropTypes.string,
    deletable: PropTypes.bool,
    time: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  }).isRequired,
  onDeleteError: PropTypes.func.isRequired,
};

class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      errors: [],
    };
    this.onDeleteError = this.onDeleteError.bind(this);
  }

  componentDidCatch(error, info) {
    let { errors } = this.state;
    errors = errors.concat([{
      deletable: false,
      cause: error,
      message: error.toString(),
      description: info.componentStack && info.componentStack,
      time: new Date().getTime(),
    }]);
    this.setState({ errors });
  }

  onDeleteError(error) {
    let { errors } = this.state;
    const index = errors.find(error);
    if (index >= 0) {
      errors = errors.concat([]);
      errors.splice(index, 1);
      this.setState({ errors });
    }
  }

  render() {
    const { errors } = this.state;

    const makeKey = (error, i) => {
      return `ErrorItem-${error.time}-${i}`;
    };
    if (errors.length) {
      // You can render any custom fallback UI
      return (
        <div className="tuc-error-ctnr">
          <div>
            <Typography variant="h4">Whoops, something went wrong!</Typography>
            <List className="tuc-error-list">
              {errors.map((error, i) => (
                <ErrorItem key={makeKey(error, i)} error={error} onDeleteError={this.onDeleteError} />
              ))}
            </List>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
